/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { SecurityHelper } from 'sarsaparilla';
import { makeAsyncAction } from '../utils/async_utils';
import {
    FETCH_PERMIT,
    SET_VALIDATION_ERROR,
    DISPLAY_UI_VALIDATIONS,
    GET_ISSUANCE_PDF_ERROR,
} from '../constants/actions';

import * as api from '../api';
import { AppDispatch } from '../../dev/store';

export const fetchPermit = makeAsyncAction(
    FETCH_PERMIT,
    (id: string) => () => api.getLocation(id),
    'facility'
);

export function formValidationChange(path: string, error: any) {
    return {
        type: SET_VALIDATION_ERROR,
        payload: { path, error },
    };
}

export function setDisplayValidationErrors() {
    return (dispatch: AppDispatch) =>
        dispatch({
            type: DISPLAY_UI_VALIDATIONS,
        });
}

export const isFirefox = () => navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

export const isMobile = {
    Android() {
        return window.navigator.userAgent.match(/Android/i);
    },
    BlackBerry() {
        return window.navigator.userAgent.match(/BlackBerry/i);
    },
    iOS() {
        return window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera() {
        return window.navigator.userAgent.match(/Opera Mini/i);
    },
    Windows() {
        return window.navigator.userAgent.match(/IEMobile/i);
    },
    any() {
        return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
        );
    },
};

export const printBlob = (blob: Blob, fileName = 'file.pdf'): Window | null | void => {
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
        // IE opens blobs this way:
        if (fileName) {
            (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
        } else {
            (window.navigator as any).msSaveOrOpenBlob(blob);
        }
    } else {
        // Other browsers use iframe printing:
        const url = window.URL.createObjectURL(blob);

        if (isMobile.any()) {
            return window.open(url, '_blank');
        }

        if (isFirefox()) {
            const downloadLink = document.createElement('a');
            downloadLink.target = '_blank';
            downloadLink.download = fileName;

            downloadLink.href = url;
            downloadLink.style.display = 'none';

            document.body.append(downloadLink);

            downloadLink.click();

            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(url);
        } else {
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            iframe.addEventListener(
                'load',
                () => {
                    setTimeout(() => {
                        iframe.contentWindow?.focus();
                        iframe.contentWindow?.print();
                    }, 0);
                },
                false
            );

            iframe.setAttribute('src', url);
        }
    }
};

export const printTreePermitPDF = (reservation: {
    order_details?: { download_url?: string };
}) => {
    const { order_details } = reservation;
    return (dispatch: AppDispatch) => {
        return axios
            .get(order_details?.download_url ?? '', {
                headers: { Authorization: SecurityHelper.getAuthHeader() },
                responseType: 'arraybuffer',
            })
            .then((response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                printBlob(blob);
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    dispatch({
                        type: GET_ISSUANCE_PDF_ERROR,
                        payload: 'error printing issuance PDF',
                        error: error.response.data,
                    });
                }
            });
    };
};
